"use client";

import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
} from "@chakra-ui/react";
import DealershipUser from "../../../components/GlobalDashboard/DealershipUser/DealershipUser";
import SimpSocialUsers from "../../../components/GlobalDashboard/SimpSocialUsers/SimpSocialUsers";
import { useState } from "react";

export default function GlobalUsers() {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (index: any) => {
    setActiveTab(index);
  };
  return (
    <>
      <VStack padding="1.5rem" w="100%" alignItems="flex-start">
        <Tabs
          variant="table"
          w="100%"
          background="white"
          borderRadius="0.5rem"
          defaultIndex={0}
          onChange={handleTabChange}
        >
          <TabList borderTopRightRadius="0.5rem">
            <Tab w="15rem">Dealership Users</Tab>
            <Tab w="15rem">SimpSocial Users</Tab>
          </TabList>
          <TabPanels w="100%" h="100%">
            <TabPanel w="100%" h="100%">
              {activeTab === 0 && <DealershipUser />}
            </TabPanel>

            <TabPanel w="100%" h="100%">
              {activeTab === 1 && <SimpSocialUsers />}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </>
  );
}
